module.exports = __webpack_public_path__ + "img/vu.609b731d.svg";